export default __webpack_public_path__ + "static/media/SideWGPLogo.a1bfaa09.jpg";